import React from "react";

const CaseDetailsSectionLatest = ({ service, lang, arPhrase, enPhrase }) => {
  const {
    id,
    serviceCategory,
    status,
    caseNumber,
    requesterEmail,
    requesterName,
    caseTypeName,
    createdAt,
    contactNumber,
    contactEmail,
    courtName,
    partyTypeName,
    caseYear,
  } = service;
  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center">
        <div className="w-full bg-white flex flex-col md:flex-row flex-wrap gap-[16px] xl:gap-y-[32px] xl:gap-x-[10px] content-between ">
          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en" ? enPhrase["lblCourt"] : arPhrase["lblCourt"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{courtName}</p>
          </div>

          <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en"
                ? enPhrase["lblCaseType"]
                : arPhrase["lblCaseType"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{caseTypeName}</p>
          </div>

          <div className="md:flex flex-col content-between  justify-start gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en"
                ? enPhrase["lblCustomerStatus"]
                : arPhrase["lblCustomerStatus"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{partyTypeName}</p>
          </div>

          <div className="md:flex flex-col content-between  justify-start gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en"
                ? enPhrase["lblCaseNumber"]
                : arPhrase["lblCaseNumber"]}
            </p>
            <p
              className={`text-sm font-bold font-Almarai text-[#010202] overflow-hidden text-ellipsis whitespace-nowrap ${service?.serviceStatusId === 1 || service?.serviceStatusId === 8 || service?.serviceStatusId === 2 ? "max-w-full" : "max-w-[200px]"}`}
            >
              {caseNumber}
            </p>
          </div>

          {contactNumber && (
            <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
              <p className="text-[12px] font-normal text-[#010202]">
                {lang === "en" ? enPhrase["lblPhone"] : arPhrase["lblPhone"]}
              </p>
              <p
                className={`text-sm font-bold text-[#010202] ${
                  lang === "en" ? "" : "text-right"
                } `}
                dir="ltr"
              >
                {contactNumber}
              </p>
            </div>
          )}

          <div className="md:flex flex-col content-between  justify-start gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
            </p>
            <p className="text-sm font-bold text-[#010202]">{caseYear}</p>
          </div>
          {contactEmail && (
            <div className="flex flex-col content-between justify-between gap-1 min-w-[45%]">
              <p className="text-[12px]  font-normal text-[#010202]">
                {lang === "en" ? enPhrase["lblEmail"] : arPhrase["lblEmail"]}:
              </p>
              <p
                className={`text-sm font-bold font-Almarai text-[#010202] overflow-hidden text-ellipsis whitespace-nowrap ${service?.serviceStatusId === 1 || service?.serviceStatusId === 8 || service?.serviceStatusId === 2} ? "max-w-full" :"max-w-[250px]" `}
              >
                {contactEmail}
              </p>
            </div>
          )}
          {/* <div className="flex flex-col  content-between justify-between gap-1 min-w-[45%]">
            <p className="text-[12px] font-normal text-[#010202]">
              {lang === "en"
                ? enPhrase["lblClaimAmount"]
                : arPhrase["lblClaimAmount"]}
              :
            </p>
            <p className="text-[16px] md:text-sm font-bold text-[#a98031] md:text-[#010202]">
              <span>{USDollar.format(claimedValue)} </span>
              <span>{lang === "en" ? "AED" : "درهم"}</span>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CaseDetailsSectionLatest;
